import { Factura } from "./types";

/** Suma los montos (campo `monto`, que el backend a veces devuelve como string). */
export function sumaMontos(facturas: Factura[]): number {
	if (!Array.isArray(facturas) || facturas.length === 0) {
		return 0;
	}
	return facturas
		.map(f => parseInt(String(f.monto), 10) || 0)
		.reduce((a, b) => a + b, 0);
}

/** Valida que la suma de montos cubra el mínimo aceptado para cotizar. */
export function cumpleMontoMinimo(facturas: Factura[], montoMinimo: number): boolean {
	return sumaMontos(facturas) >= montoMinimo;
}
